"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.prepareProductForDataLayer = exports.getListClasses = exports.getLength = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _promotionLink = _interopRequireDefault(require("./promotion-link"));
var _productLinks = _interopRequireDefault(require("./product-links"));
var _subNavLinks = _interopRequireDefault(require("./sub-nav-links"));
var dataUtils = new _mmcDataUtilities["default"]();
var formatAsMKSPath = dataUtils.formatAsMKSPath,
  isEmptyArray = dataUtils.isEmptyArray;
var prepareProductForDataLayer = function prepareProductForDataLayer(product, currencyFormat) {
  if (product) {
    var clonedProduct = JSON.parse(JSON.stringify(product));
    if (clonedProduct.cta && clonedProduct.cta.url) {
      clonedProduct.cta.url = formatAsMKSPath(clonedProduct.cta.url);
    }
    if (clonedProduct.price) {
      clonedProduct.price.currency = currencyFormat;
    }
    return clonedProduct;
  }
  return product;
};
exports.prepareProductForDataLayer = prepareProductForDataLayer;
var getListClasses = function getListClasses(params) {
  var menuOpen = params.menuOpen,
    theme = params.theme,
    isLast = params.isLast;
  return _navigationHeader["default"].navBtnItem + " " + (menuOpen ? null : theme.grey) + " " + _navigationHeader["default"].subColumnWrap + " " + (isLast ? _navigationHeader["default"].lastBtnItem : '') + " menu-panel-top-level-item";
};
exports.getListClasses = getListClasses;
var getLength = function getLength(arr) {
  return arr && arr.length;
};
exports.getLength = getLength;
var clickHandlerProduct = function clickHandlerProduct(url, linkName, clickHandler) {
  clickHandler();
  if (window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'navclick',
      component: 'top_nav',
      action: 'nav_link',
      click_text: linkName,
      click_url: url,
      section: ''
    });
  }
};
var MenuPanelSubColumn = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(MenuPanelSubColumn, _React$Component);
  function MenuPanelSubColumn(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var keyHandler = props.keyHandler || _this.keyHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.focusHandler = _this.focusHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.refList = {};
    _this.state = {
      keyHandler: keyHandler
    };
    _this.handleMouseDownToggle = _this.handleMouseDownToggle.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = MenuPanelSubColumn.prototype;
  _proto.handleMouseDownToggle = function handleMouseDownToggle() {
    var _this$props = this.props,
      currentPath = _this$props.currentPath,
      products = _this$props.products,
      _this$props$config = _this$props.config,
      market = _this$props$config.market,
      currencyFormat = _this$props$config.currencyFormat,
      name = _this$props.name;
    if (market.toLowerCase() === 'mx' && typeof window !== 'undefined' && window.dataLayer && products && products.length > 0) {
      var productsClone = [];
      products.forEach(function (product) {
        productsClone.push(prepareProductForDataLayer(product, currencyFormat));
      });
      window.dataLayer.push({
        event: 'view_item_list',
        view_item_listdata: [{
          position: 'Header',
          items: productsClone.map(function (product) {
            return prepareProductForDataLayer(product, currencyFormat);
          }),
          item_list_name: name,
          layer: formatAsMKSPath(currentPath)
        }]
      });
    }
  };
  _proto.keyHandler = function keyHandler() {
    var keyHandlerMethod = this.props.keyHandlerMethod;
    keyHandlerMethod.apply(void 0, arguments);
  };
  _proto.focusHandler = function focusHandler() {
    var focusHandler = this.props.focusHandler;
    if (focusHandler !== undefined) {
      focusHandler(true);
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      name = _this$props2.name,
      keyHandler = _this$props2.keyHandler,
      clickHandler = _this$props2.clickHandler,
      activeNav = _this$props2.activeNav,
      subNavigationcontainer = _this$props2.subNavigationcontainer,
      addPriceDisclaimer = _this$props2.addPriceDisclaimer,
      priceDisclaimerId = _this$props2.priceDisclaimerId,
      disclaimerData = _this$props2.disclaimerData,
      setSize = _this$props2.setSize,
      posInSet = _this$props2.posInSet,
      menuOpen = _this$props2.menuOpen,
      isLast = _this$props2.isLast,
      theme = _this$props2.theme,
      links = _this$props2.links,
      products = _this$props2.products,
      displayNavInTwoColumns = _this$props2.displayNavInTwoColumns,
      market = _this$props2.market,
      config = _this$props2.config,
      currentPath = _this$props2.currentPath,
      keyHandlerMethod = _this$props2.keyHandlerMethod,
      mobileNavActive = _this$props2.mobileNavActive; // eslint-disable-line
    var subNavigationItems = subNavigationcontainer.subNavigationItems,
      promoterDetails = subNavigationcontainer.promoterDetails;
    var id = name.toLowerCase();
    var layout = products.length > 0 ? 'products' : 'feature';
    var linkSetSize = getLength(links) ? links.length : 0;
    var productSetSize = getLength(products) ? products.length : 0;
    var totalSetSize = linkSetSize + productSetSize;
    var expanded = activeNav === id && menuOpen && !mobileNavActive;
    var hasPopUp = !!(linkSetSize || productSetSize);
    var reducedHeight = !(links.length > 0 && products.length === 0);
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: getListClasses({
        menuOpen: menuOpen,
        theme: theme,
        isLast: isLast
      }),
      role: "menuitem",
      "aria-expanded": expanded,
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "aria-haspopup": hasPopUp,
      "data-menu-item-name": name
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: _navigationHeader["default"].navBtn + " " + theme.lowIcon + " " + theme.mmcIconChevronDown,
      onKeyDown: keyHandler,
      onFocus: this.focusHandler,
      onClick: function onClick() {
        return clickHandlerProduct(name, clickHandler);
      },
      onMouseDown: this.handleMouseDownToggle,
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement("span", null, name)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].navPanel + " " + _navigationHeader["default"].restrictHeight + " " + _navigationHeader["default"][layout] + " " + (_navigationHeader["default"][id] ? _navigationHeader["default"][id] : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].innerLinkContainer + " " + (displayNavInTwoColumns === true ? _navigationHeader["default"].displayNavInTwoColumns : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "products"
    }, /*#__PURE__*/_react["default"].createElement(_productLinks["default"], {
      products: products,
      theme: theme,
      totalSetSize: totalSetSize,
      name: name,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      market: market,
      config: config,
      currentPath: currentPath,
      keyHandlerMethod: keyHandlerMethod
    })), !isEmptyArray(subNavigationItems) && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _navigationHeader["default"].navPromoWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-sm-7'] + " " + theme['col-sm-offset-1'] + " " + theme['col-xs-12'] + " " + _navigationHeader["default"].subNavigationContainer
    }, /*#__PURE__*/_react["default"].createElement(_subNavLinks["default"], {
      reducedHeight: reducedHeight,
      totalSetSize: totalSetSize,
      name: name,
      displayNavInTwoColumns: displayNavInTwoColumns,
      market: market,
      theme: theme,
      subNavigationItems: subNavigationItems,
      keyHandlerMethod: keyHandlerMethod
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-xs-4']
    }, /*#__PURE__*/_react["default"].createElement(_promotionLink["default"], (0, _extends2["default"])({}, promoterDetails, {
      theme: theme
    })))))));
  };
  return MenuPanelSubColumn;
}(_react["default"].Component);
MenuPanelSubColumn.displayName = 'MenuPanelSubColumn';
MenuPanelSubColumn.defaultProps = {
  links: [],
  products: []
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(MenuPanelSubColumn);
exports["default"] = _default;